module.exports = __webpack_public_path__ + "img/9.256ca421.png";